<!-- @format -->

<template>
	<span class="popverSty">
		<el-popover
			ref="pop"
			v-model:visible="pop"
			:placement="placement"
			width="300"
			popper-class="putMenuPopover"
			trigger="click"
		>
			<template #reference>
				<el-button v-if="!userInput">
					<template v-if="value">
						<el-icon :size="20">
							<component :is="svgComps[value] || value"></component>
						</el-icon>
					</template>
					{{ value ? (showLabel ? value : '') : placeholder }}
				</el-button>
			</template>
			<template v-if="pop">
				<el-row v-if="clearable" type="flex" justify="end" class="platform-mb-10">
					<el-button type="danger" size="small" class="platform-fr" @click="selectIcon()"> 清空 </el-button>
				</el-row>
				<el-input v-model="searchText" placeholder="请选择" class="platform-mb-10" />
				<el-collapse v-if="!searchMode" v-model="collapseActive" class="pc-iconselect--group">
					<el-collapse-item
						v-for="(item, index) in fontIcon"
						:key="index"
						:title="item.key"
						:name="index"
						class="pc-iconselect--class"
					>
						<el-row class="pc-iconselect--class-row">
							<el-col
								v-for="(iconName, iconIndex) in item.icon"
								:key="iconIndex"
								class="pc-iconselect--class-col"
								:span="4"
								@click="selectIcon(iconName)"
							>
								<el-tooltip :content="iconName" placement="top">
									<el-icon :size="16">
										<component :is="svgComps[iconName] || iconName"></component>
									</el-icon>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-collapse-item>
				</el-collapse>
				<div v-if="searchMode" class="pc-iconselect--group">
					<div v-for="(item, index) in iconFilted" :key="index" class="pc-iconselect--class">
						<div class="pc-iconselect--class-title">{{ item.title }}</div>
						<el-row class="pc-iconselect--class-row">
							<el-col
								v-for="(iconName, iconIndex) in item.icon"
								:key="iconIndex"
								class="pc-iconselect--class-col"
								:span="4"
								@click="selectIcon(iconName)"
							>
								<el-tooltip :content="iconName" placement="top">
									<el-icon :size="20">
										<component :is="iconName"></component>
									</el-icon>
								</el-tooltip>
							</el-col>
						</el-row>
					</div>
				</div>
			</template>
		</el-popover>
	</span>
</template>

<script>
	import fontIcon from './data';
	import { svgComps } from '@/assets/icons/vue';

	export default {
		props: {
			value: {
				type: String,
			},
			data: {
				type: Object,
			},
			// 占位符
			placeholder: {
				type: String,
				required: false,
				default() {
					return '请选择';
				},
			},
			icon: {
				type: String,
				default: 'el-icon-search"',
			},
			// 弹出界面的方向
			placement: {
				type: String,
				required: false,
				default: 'right',
			},
			// 是否可清空
			clearable: {
				type: Boolean,
				required: false,
				default: true,
			},
			// 是否允许用户输入
			userInput: {
				type: Boolean,
				required: false,
				default: false,
			},
			// 是否在选择后自动关闭
			autoClose: {
				type: Boolean,
				required: false,
				default: true,
			},
			showLabel: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				// value: '',
				// 绑定弹出框
				pop: false,
				// 组件内输入框的值
				currentValue: '',
				// 搜索的文字
				searchText: '',
				// 不是搜索的时候显示的折叠面板绑定的展开数据
				// collapseActive: [],
				collapseActive: [...Array(fontIcon.length)].map((e, i) => i),
				svgComps,
			};
		},
		computed: {
			fontIcon() {
				return this.data ? this.data : fontIcon;
			},
			// 是否在搜索
			searchMode() {
				return !!this.searchText;
			},
			// 过滤后的图标
			iconFilted() {
				return this.fontIcon
					.map((iconClass) => ({
						title: iconClass.title,
						icon: iconClass.icon.filter((icon) => icon.indexOf(this.searchText) >= 0),
					}))
					.filter((iconClass) => iconClass.icon.length > 0);
			},
		},
		watch: {
			value(value) {
				this.currentValue = value;
			},
		},
		created() {
			this.currentValue = this.value;
		},
		beforeUnmount() {
			this.collapseActive = null;
		},
		methods: {
			selectIcon(iconName = '') {
				// this.value = iconName || ''
				this.$emit('callback', iconName);
				if (iconName && this.autoClose) {
					this.pop = false;
				}
			},
		},
	};
</script>

<style lang="scss">
	.el-popover.putMenuPopover {
		background: #fff !important;
	}

	.pc-iconselect--group {
		max-height: 400px;
		overflow-x: hidden;
		overflow-y: scroll;
		border-top: none;
		border-bottom: none;

		.pc-iconselect--class {
			.pc-iconselect--class-title {
				line-height: 30px;
				text-align: center;
				background-color: #f8f8f9;
				border-radius: 4px;
				margin: 10px 0px;
			}

			.pc-iconselect--class-row {
				.pc-iconselect--class-col {
					line-height: 40px;
					text-align: center;
					color: #909399;

					&:hover {
						color: #303133;
						background-color: #f8f8f9;
						border-radius: 4px;
						font-size: 26px;
						box-shadow: inset 0px 0px 0px 1px #dcdfe6;
					}
				}
			}
		}

		.el-collapse-item__header {
			background: #fff !important;
		}

		.el-collapse-item__content {
			background: #fff !important;
		}
	}
</style>
